import { useEffect, useRef } from 'react'
import { useProgramContext } from '@/context/ProgramContext'
import { useTeamContext } from '@/context/TeamContext'

export function useProgram() {
	const { teamId } = useTeamContext()
	const programContext = useProgramContext()
	const fetchProgramsRef = useRef(programContext.fetchPrograms)

	// Update the ref when fetchPrograms changes
	useEffect(() => {
		fetchProgramsRef.current = programContext.fetchPrograms
	}, [programContext.fetchPrograms])

	useEffect(() => {
		if (!teamId) return

		// Fetch programs when teamId changes
		fetchProgramsRef.current(teamId)
	}, [teamId]) // Remove programContext from dependencies

	return {
		...programContext,
		teamId: teamId, // Add teamId from useTeam() to the returned object
	}
}
